<template>
	<base-focus-trap
		:disabled="!visible"
		:class="{
			'invisible': !visible
		}"
		id="vue-overlay-search"
		class="z-a1 fixed inset-0 transition-alpha">

		<!-- Background mask,  -->
		<div class="inset-0 absolute bg-black-80 cursor-pointer z-0" @click="dismiss"></div>

		<div class="h-full w-full overflow-auto no-overscroll relative z-1 flex items-center justify-center">

			<!-- Modal will go into this...but there's no styling, do this on the modal container...unless you want a global style... -->
			
			<div v-if="loading" class="relative uppercase tracking-wide font-bold z-1 m-auto p-2 text-green">
				<div class="text-14 lds mr-2"><div></div><div></div><div></div></div>
				Loading...
			</div>

			<div :class="{
				'hidden': loading,
			}"
			class="relative z-1 m-auto" ref="content"></div>
		</div>

		<button class="no-mouse-focus" @click="dismiss"></button>

	</base-focus-trap>
</template>
<script>

export default {

	computed: {
		visible() {
			return this.$root.visible;
		},
		content() {
			return this.$root.content;
		},
		loading() {
			
			return this.$root.loading;
		}
	},
	watch: {
		content( newValue ) {
			if ( newValue ) {
				this.$refs.content.innerHTML = newValue;
				// add any event listeners for dismissers...
				this.$nextTick( () => {
					const buttons = this.$refs.content.querySelectorAll('button[data-dismiss]');
					buttons.forEach( b => {
						const remove = () => {
							this.dismiss();
							b.removeEventListener('click', remove );
						};
						b.addEventListener('click', remove );
					});
				});
			} else {
				this.$refs.content.innerHTML = '';
			}
		},
		visible( newValue ) {
			if ( newValue ) {
				document.body.style.overflow = 'hidden';
			} else {
				document.body.style.overflow = 'visible';
			}
		},
	},
	mounted() {
		window.addEventListener('keydown', this.onClose );
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.onClose );
	},
	methods: {
		onClose( e ) {
			if ( this.visible && e.key === 'Escape' ) {
				this.dismiss();
			}
		},
		dismiss() {
			this.$root.visible = false;
			// This is a bad coupling with the parent, but here we are...
			history.pushState( this.$root.initialState, this.$root.dismissTitle, this.$root.dismissUrl );
		}
	}
}
</script>
<style lang="scss" scoped>
@use 'sass:math';

.transition-alpha {

	transition: opacity .3s ease;

	&.invisible {
		opacity: 0;
		transition: opacity .3s ease, visibility 0s linear .3s;
	}
}



.lds {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  width: 1em;
  height: 1em;
}
.lds div {
  display: inline-block;
  position: absolute;
  left: math.div(6, 60) * 1em;
  width: math.div(13, 60) * 1em;
  background: currentColor;
  animation: lds 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds div:nth-child(1) {
  left: math.div(6, 60) * 1em;
  animation-delay: -0.24s;
}
.lds div:nth-child(2) {
  left: math.div(26, 60) * 1em;
  animation-delay: -0.12s;
}
.lds div:nth-child(3) {
  left: math.div(45, 60) * 1em;
  animation-delay: 0;
}
@keyframes lds {
  0% {
    top: math.div(6, 60) * 1em;
    height: math.div(51, 60) * 1em;
  }
  50%, 100% {
    top: math.div(19, 60) * 1em;
    height: math.div(26, 60) * 1em;
  }
}

</style>
